import { useEffect } from "react"
import { usePageContext } from "vike-react/usePageContext"

export default function ScrollToHash() {
  const pageContext = usePageContext()
  // Safely get current path - only access pageContext properties that are guaranteed to be available
  const currentPath = (typeof window !== 'undefined') 
    ? window.location.pathname 
    : (pageContext?.urlPathname || '/')
  
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const scrollToHash = () => {
        const hash = window.location.hash
        if (!hash) return
        
        // Small delay to ensure the DOM is fully rendered
        setTimeout(() => {
          const element = document.querySelector(hash)
          if (element) {
            element.scrollIntoView({ 
              behavior: 'smooth', 
              block: 'start',
              inline: 'nearest'
            })
          }
        }, 100)
      }
      
      // Scroll on initial load
      scrollToHash()
      
      // Listen for hash changes (for navigation within the same page)
      const handleHashChange = () => {
        scrollToHash()
      }
      
      window.addEventListener('hashchange', handleHashChange)
      
      return () => {
        window.removeEventListener('hashchange', handleHashChange)
      }
    }
  }, [currentPath]) // Re-run when the path changes
  
  return null
}